export default __webpack_public_path__ + "static/cartaz-a0901a19edf35f68b175ab0c332811d0.jpg";